/* eslint-disable no-return-assign */
/* eslint-disable no-plusplus */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useRef, useState } from "react";
import { useMap } from "context/mapContext";
import Slider from "@arcgis/core/widgets/Slider";
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine";
import Graphic from "@arcgis/core/Graphic";
import SketchViewModel from "@arcgis/core/widgets/Sketch/SketchViewModel";
import getEsriSpatialData from "context/contextFunctions/getEsriSpatialData";
import PropTypes from "prop-types";
import handleZoom from "utils/handleZoom";

let featureLayerView;
let filterGeometry = null;

let bufferSize = 0;
let sketchGeometry = null;
let selectedFilter = "intersects";

function Map(props) {
  const [map, dispatchMap] = useMap();
  const {
    mapDiv,
    view,
    webMap,
    polesLayer,
    polesList,
    workordersComponentMode,
    installationTasksComponentMode,
    graphicsLayer,
    munQuery,
    polesSelectionComponentMode,
    sketchLayer,
    bufferLayer,
    showDrawTools,
  } = map;

  const [sktechVMState, setSktechVMState] = useState(null);

  const spatialRelType = useRef(null);
  const infoDiv = useRef(null);
  const [bufferNumSlider, setBufferNumSlider] = useState(null);

  const { selectedTool } = props;

  // const showDiv =
  //   selectedTool === "polesSelection" &&
  //   polesSelectionComponentMode === "newJobZone";

  // update the filter geometry depending on bufferSize
  function updateFilterGeometry() {
    // add a polygon graphic for the bufferSize
    if (sketchGeometry) {
      if (bufferSize > 0) {
        const bufferGeometry = geometryEngine.geodesicBuffer(
          sketchGeometry,
          bufferSize,
          "meters"
        );
        if (bufferLayer.graphics.length === 0) {
          bufferLayer.add(
            new Graphic({
              geometry: bufferGeometry,
              symbol: {
                type: "simple-fill",
                color: [151, 151, 204, 0.5],
                style: "solid",
                outline: {
                  color: "white",
                  width: 1,
                },
              },
            })
          );
        } else {
          bufferLayer.graphics.getItemAt(0).geometry = bufferGeometry;
        }
        filterGeometry = bufferGeometry;
      } else {
        bufferLayer.removeAll();
        filterGeometry = sketchGeometry;
      }
    }
  }

  // set the geometry filter on the visible FeatureLayerView
  async function updateFilter() {
    updateFilterGeometry();
    const featureFilter = {
      // autocasts to FeatureFilter
      geometry: filterGeometry,
      spatialRelationship: selectedFilter,
    };

    if (featureLayerView) {
      // featureLayerView.filter = featureFilter;
      // if (selectedFilter === "intersects") view.goTo(filterGeometry);
      if (polesLayer) {
        const { res: newPolesRes } = await getEsriSpatialData({
          ...featureFilter,
          returnGeometry: true,
          view,
          outFields: "*",
          featureLayer: polesLayer,
          query:
            !munQuery || munQuery === "1=1"
              ? "Status IS NULL"
              : `${munQuery} AND Status IS NULL`,
          neededDomains: ["Pole_Type"],
        });

        handleZoom(newPolesRes, view, graphicsLayer);
        dispatchMap({
          type: "INIT",
          payload: {
            polesList: newPolesRes,
            selectionGeometry: filterGeometry,
          },
        });
      }
    }
  }

  function clearFilter() {
    sketchGeometry = null;
    filterGeometry = null;
    sketchLayer.removeAll();
    bufferLayer.removeAll();
    // graphicsLayer.removeAll();
    // featureLayerView.filter = null;
  }

  function bufferVariablesChanged(event) {
    bufferSize = event.value;
    updateFilter();
  }

  function geometryButtonsClickHandler(event) {
    const geometryType = event.target.value;
    clearFilter();
    sktechVMState?.create(geometryType);
  }

  const handleChangeSpatialRelationship = (event) => {
    // get the selected spatialRelationship
    const select = event.target;
    selectedFilter = select.options[select.selectedIndex].value;
    updateFilter();
  };

  useEffect(() => {
    webMap?.load().then(() => {
      // loop through webmap's operational layers
      view.map.layers.forEach((layer) => {
        view
          .whenLayerView(layer)
          .then((layerView) => {
            if (layer.type === "feature") {
              featureLayerView = layerView;
            }
          })
          .catch(console.error);
      });
    });

    // add predefined point, line and polygon features
    view?.when(() => {
      // add a GraphicsLayer for the sketches and the buffer
      webMap?.addMany([bufferLayer, sketchLayer]);

      if (!bufferNumSlider) {
        const slider = new Slider({
          container: "bufferNum",
          min: 0,
          max: 1000,
          steps: 1,
          visibleElements: {
            labels: true,
          },
          precision: 0,
          labelFormatFunction: (value) => `${value.toString()}m`,
          values: [0],
        });
        slider?.on(["thumb-change", "thumb-drag"], bufferVariablesChanged);
        setBufferNumSlider(slider);
      }

      // use SketchViewModel to draw polygons that are used as a filter
      const sketchViewModel = new SketchViewModel({
        layer: sketchLayer,
        view,
        pointSymbol: {
          type: "simple-marker",
          style: "circle",
          size: 10,
          color: [255, 255, 255, 0.8],
          outline: {
            color: [211, 132, 80, 0.7],
            size: 10,
          },
        },
        polylineSymbol: {
          type: "simple-line",
          color: [51, 51, 204, 0.5],
          width: "4px",
        },
        polygonSymbol: {
          type: "simple-fill", // autocasts as new SimpleFillSymbol()
          color: [51, 51, 204, 0.2],
          style: "solid",
          outline: {
            color: "white",
            width: 1,
          },
        },
        defaultCreateOptions: { hasZ: false },
      });

      setSktechVMState(sketchViewModel);

      sketchViewModel.on(["create"], (event) => {
        // update the filter every time the user finishes drawing the filtergeometry
        if (event.state === "complete") {
          sketchGeometry = event.graphic.geometry;
          updateFilter();
        }
      });

      sketchViewModel.on(["update"], (event) => {
        const eventInfo = event.toolEventInfo;
        // update the filter every time the user moves the filtergeometry
        if (eventInfo && eventInfo.type.includes("move")) {
          if (eventInfo.type === "move-stop") {
            sketchGeometry = event.graphics[0].geometry;
            updateFilter();
          }
        }
        // update the filter every time the user changes the vertices of the filtergeometry
        if (eventInfo && eventInfo.type.includes("reshape")) {
          if (eventInfo.type === "reshape-stop") {
            sketchGeometry = event.graphics[0].geometry;
            updateFilter();
          }
        }
      });

      if (infoDiv.current) infoDiv.current.style.display = "block";
    });
  }, [
    view,
    webMap,
    polesLayer,
    polesList,
    installationTasksComponentMode,
    workordersComponentMode,
    selectedTool,
    munQuery,
    polesSelectionComponentMode,
    showDrawTools,
  ]);

  useEffect(() => {
    let toggleDrawToolsButton = document.getElementById("toggleDrawTools");
    if (!toggleDrawToolsButton) {
      toggleDrawToolsButton = document.createElement("div");
      toggleDrawToolsButton.className =
        "esri-widget--button esri-widget esri-interactive esri-icon-cursor-marquee";
      toggleDrawToolsButton.id = "toggleDrawTools";
    }
    toggleDrawToolsButton.onclick = () => {
      dispatchMap({
        type: "INIT",
        payload: {
          showDrawTools: !showDrawTools,
        },
      });
    };

    view?.when(() => {
      view.ui.add(toggleDrawToolsButton, "top-right");
    });
  }, [showDrawTools, view]);

  return (
    <>
      <div className="mapDiv" ref={mapDiv} />
      {showDrawTools && (
        <div id="infoDiv" className="esri-widget" ref={infoDiv}>
          <b>Filter by geometry</b>
          <br />
          Draw a geometry to filter by:
          <div className="geometry-options">
            <button
              type="button"
              className="esri-widget--button esri-icon-map-pin geometry-button"
              id="point-geometry-button"
              value="point"
              title="Filter by point"
              onClick={geometryButtonsClickHandler}
            />
            <button
              type="button"
              className="esri-widget--button esri-icon-polyline geometry-button"
              id="line-geometry-button"
              value="polyline"
              title="Filter by line"
              onClick={geometryButtonsClickHandler}
            />
            <button
              type="button"
              className="esri-widget--button esri-icon-polygon geometry-button"
              id="polygon-geometry-button"
              value="polygon"
              title="Filter by polygon"
              onClick={geometryButtonsClickHandler}
            />
          </div>
          <br />
          <label htmlFor="relationship-select">Spatial relationship:</label>
          <select
            id="relationship-select"
            className="options"
            onChange={handleChangeSpatialRelationship}
            ref={spatialRelType}
          >
            <option value="intersects" selected>
              intersects
            </option>
            <option value="contains">contains</option>
            <option value="disjoint">disjoint</option>
          </select>
          <br />
          <br />
          <label htmlFor="bufferNum">Set a geometry buffer size:</label>
          <div id="bufferNum" />
          <br />
          <br />
          <button
            className="esri-button"
            id="clearFilter"
            type="button"
            onClick={clearFilter}
          >
            Clear Drawings
          </button>
        </div>
      )}
    </>
  );
}

Map.propTypes = {
  selectedTool: PropTypes.string.isRequired,
};

export default Map;
